module.exports = __webpack_public_path__ + "img/droplet-slash.79ddb164.svg";